/** @format */

import React from 'react';
import './styles.scss';
// import { Button } from 'react-bootstrap';

export const Selector = ({
  wrapperClassName,
  buttonClassName,
  onClick,
  children
}) => {
  return (
    <div
      className={`${wrapperClassName} ${buttonClassName} leads-from-checkbox-wrapper`}
      onClick={onClick}>
      <input type='checkbox' />
      <label>
        <span></span>
        {children}
      </label>
    </div>
  );
};
